import { db, storage } from "@/firebase";
import { ref } from "firebase-functions/lib/providers/database";

export default {
	getProductos({ commit, rootState }) {
		let devolver = [];
		let negocio = rootState.app.negocioGest;
		db.collection("negocios")
			.doc(negocio)
			.collection("productos")
			.get()
			.then((res) => {
				res.forEach((doc) => {
					let aux = doc.data();
					aux.id = doc.id;
					devolver.push(aux);
				});
				return devolver;
			})
			.then((res) => {
				var actions = res.map(function (item) {
					if (item.imagen) {
						return item;
					} else {
						return item;
						var storageRef = storage.ref(
							"imagenes/productos/" + item.id + ".jpg"
						);
						//var spaceRef = storageRef.child('imagenes/caracteristicas/' + element.id + '.jpg');
						return storageRef
							.getDownloadURL()
							.then((r) => {
								item.imagen = r;
								return db
									.collection("negocios")
									.doc(negocio)
									.collection("productos")
									.doc(item.id)
									.set(
										{
											imagen: r,
										},
										{ merge: true }
									);
								//   return item;
							})
							.then((r) => item)
							.catch((e) => {
								console.log(e);
								item.imagen = false;
								return item;
							});
					}
				});
				return Promise.all(actions)
					.then((r) => {
						commit("setProductosArray", r);
					})
					.catch((e) => {
						console.log(e);
					});
			});
	},
	getGruposModificadores({ commit, rootState }) {
		let devolver = [];
		let negocio = rootState.app.negocioGest;
		return db
			.collection("negocios")
			.doc(negocio)
			.collection("productosGruposModificadores")
			.get()
			.then((res) => {
				commit(
					"setGruposModificadores",
					res.docs.map((g) => {
						return {
							...g.data(),
							id: g.id,
						};
					})
				);
			});
	},
	addGrupoModificador({ rootState }, data) {
		let negocio = rootState.app.negocioGest;
		let id = data.id;
		delete data.id;
		var ref;
		if (id) {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosGruposModificadores")
				.doc(id)
				.set(data, { merge: true });
		} else {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosGruposModificadores")
				.add(data);
		}
		return ref;
	},
	addMenu({ rootState }, data) {
		let negocio = rootState.app.negocioGest;
		let id = data.id;
		var imagen = data.imagenModel;
		delete data.id;
		delete data.imagenModel;
		var ref;
		if (id) {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosMenus")
				.doc(id)
				.set(data, { merge: true });
		} else {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosMenus")
				.add(data);
		}
		if (imagen) {
			console.log(imagen);
			return ref
				.then((res) => {
					if (!id) {
						id = res.id;
					}
					var storageRef = storage.ref();
					var ref = storageRef.child(
						"imagenes/productos/" + id + ".jpg"
					);
					return ref
						.put(imagen)
						.then(() => ref.getDownloadURL())
						.then((r) => {
							//item.imagen = r;
							return db
								.collection("negocios")
								.doc(negocio)
								.collection("productosMenus")
								.doc(id)
								.set(
									{
										imagen: r,
									},
									{ merge: true }
								);
							//   return item;
						})
						.then(() => id);
				})
				.catch((e) => console.log(e));
		} else {
			return ref.then((res) => {
				console.log(res);
				if (!id) {
					id = res.id;
					console.log(id);
				}
				console.log(id);
				return id;
			});
		}
		return ref;
	},
	deleteGrupoModificador({ rootState }, data) {
		let negocio = rootState.app.negocioGest;
		let id = data.id;
		delete data.id;
		var ref;
		if (id) {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosGruposModificadores")
				.doc(id)
				.delete();
		}
		return ref;
	},
	deleteModificador({ rootState }, data) {
		let negocio = rootState.app.negocioGest;
		let id = data.id;
		delete data.id;
		var ref;
		if (id) {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosModificadores")
				.doc(id)
				.delete();
		}
		return ref;
	},
	getModificadores({ commit, rootState }) {
		let devolver = [];
		let negocio = rootState.app.negocioGest;
		return db
			.collection("negocios")
			.doc(negocio)
			.collection("productosModificadores")
			.get()
			.then((res) => {
				commit(
					"setModificadores",
					res.docs.map((g) => {
						return {
							...g.data(),
							id: g.id,
						};
					})
				);
			});
	},
	getGrupoModificador({ rootState }, id) {
		let negocio = rootState.app.negocioGest;

		var ref;
		if (id) {
			return db
				.collection("negocios")
				.doc(negocio)
				.collection("productosGruposModificadores")
				.doc(id)
				.get()
				.then((r) => {
					if (!r.exists) return Promise.reject("no existe");
					return {
						...r.data(),
						id: id,
					};
				});
		}
	},
	addModificador({ rootState }, dataBruto) {
		let data = { ...dataBruto };
		let negocio = rootState.app.negocioGest;
		let id = data.id;
		delete data.id;
		var ref;
		if (id) {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosModificadores")
				.doc(id)
				.set(data, { merge: true });
		} else {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosModificadores")
				.add(data);
		}
		return ref;
	},
	getModificador({ rootState }, id) {
		let negocio = rootState.app.negocioGest;
		var ref;
		if (id) {
			return db
				.collection("negocios")
				.doc(negocio)
				.collection("productosModificadores")
				.doc(id)
				.get()
				.then((r) => {
					if (!r.exists) return Promise.reject("no existe");
					return {
						...r.data(),
						id: id,
					};
				});
		}
	},
	getTarifas({ commit, rootState }) {
		let devolver = [];
		let negocio = rootState.app.negocioGest;
		return db
			.collection("negocios")
			.doc(negocio)
			.collection("productosTarifas")
			.get()
			.then((res) => {
				commit(
					"setTarifas",
					res.docs.map((g) => {
						return {
							...g.data(),
							id: g.id,
						};
					})
				);
			});
	},
	addTarifa({ rootState }, data) {
		let negocio = rootState.app.negocioGest;
		let id = data.id;
		delete data.id;
		var ref;
		if (id) {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosTarifas")
				.doc(id)
				.set(data, { merge: true });
		} else {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosTarifas")
				.add(data);
		}
		return ref;
	},
	eliminarTarifa({ rootState }, data) {
		let negocio = rootState.app.negocioGest;
		let id = data.id;
		return db
			.collection("negocios")
			.doc(negocio)
			.collection("productosTarifas")
			.doc(id)
			.delete();
	},
	getMenus({ commit, rootState }) {
		let devolver = [];
		let negocio = rootState.app.negocioGest;
		return db
			.collection("negocios")
			.doc(negocio)
			.collection("productosMenus")
			.get()
			.then((res) => {
				commit(
					"setMenus",
					res.docs.map((g) => {
						return {
							...g.data(),
							id: g.id,
						};
					})
				);
			});
	},
	getMenu({ rootState }, id) {
		let negocio = rootState.app.negocioGest;
		var ref;
		console.log(id);
		if (id) {
			return db
				.collection("negocios")
				.doc(negocio)
				.collection("productosMenus")
				.doc(id)
				.get()
				.then((r) => {
					if (!r.exists) return Promise.reject("no existe");
					return {
						...r.data(),
						id: id,
					};
				});
		}
	},
	deleteMenu({ rootState }, data) {
		let negocio = rootState.app.negocioGest;
		let id = data.id;
		delete data.id;
		var ref;
		if (id) {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productosMenus")
				.doc(id)
				.delete();
		}
		return ref;
	},
	ordenarMenus({ rootState }, array) {
		let negocio = rootState.app.negocioGest;
		let arrayPromesas = [];
		array.forEach((element) => {
			arrayPromesas.push(
				db
					.collection("negocios")
					.doc(negocio)
					.collection("productosMenus")
					.doc(element.id)
					.set({ orden: element.orden }, { merge: true })
			);
		});
		return Promise.all(arrayPromesas);
	},

	addProductoLote({ dispatch }, data) {
		return Promise.all(
			data.map((p) => {
				console.log(p);
				delete p.imagen;
				return !!p.menu
					? dispatch("addMenu", p)
					: dispatch("addProducto", p);
			})
		);
	},
	addProducto({ rootState }, prod) {
		let negocio = rootState.app.negocioGest;
		let id = prod.id;
		let imagen = prod.imagen;
		delete prod.id;
		delete prod.imagen;
		var ref = null;
		if (id) {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productos")
				.doc(id)
				.set(prod, { merge: true });
		} else {
			ref = db
				.collection("negocios")
				.doc(negocio)
				.collection("productos")
				.add(prod);
		}
		if (imagen) {
			return ref
				.then((res) => {
					if (!id) {
						id = res.id;
					}
					var storageRef = storage.ref();
					var refS = storageRef.child(
						"imagenes/productos/" + id + ".jpg"
					);
					return refS
						.put(imagen)
						.then(() => refS.getDownloadURL())
						.then((r) => {
							//item.imagen = r;
							return db
								.collection("negocios")
								.doc(negocio)
								.collection("productos")
								.doc(id)
								.set(
									{
										imagen: r,
									},
									{ merge: true }
								)
								.then((r) => {
									return { id: id };
								});
							//   return item;
						});
				})
				.catch((e) => console.log(e));
		} else {
			return ref;
		}
	},
	saveMapeo({ rootState }, prd) {
		let negocio = rootState.app.negocioGest;
		let id = prd.id;
		delete prd.id;
		return db
			.collection("negocios")
			.doc(negocio)
			.collection("productos")
			.doc(id)
			.set(prd, { merge: true });
	},
	deleteProducto({ rootState }, item) {
		let negocio = rootState.app.negocioGest;
		return db
			.collection("negocios")
			.doc(negocio)
			.collection("productos")
			.doc(item.id)
			.delete();
	},
	duplicateProducto({ rootState }, item) {
		let copia = item;

		delete copia.nombreMostrar;
		delete copia.descripcionMostrar;
		delete copia.categoriaMostrar;
		copia.esCopia = copia.id;
		delete copia.id;
		let negocio = rootState.app.negocioGest;

		return db
			.collection("negocios")
			.doc(negocio)
			.collection("productos")
			.add(copia);

		//return db.collection('negocios').doc(negocio).collection('productos').doc(item.id).delete();
	},
	ordenarProductos({ rootState }, array) {
		let negocio = rootState.app.negocioGest;
		let arrayPromesas = [];
		array.forEach((element) => {
			arrayPromesas.push(
				db
					.collection("negocios")
					.doc(negocio)
					.collection("productos")
					.doc(element.id)
					.set({ orden: element.orden }, { merge: true })
			);
		});
		return Promise.all(arrayPromesas);
	},
	saveAsociacionPorLote({}, payload) {
		let rest = payload.restaurante;
		let asociaciones = payload.asociaciones;
		return db.collection("restaurantes").doc(rest).set(
			{
				productosAsociados: asociaciones,
			},
			{ merge: true }
		);
	},
};
